<div class="ml-2">
  <bpt-search  appBlurOnSearch *ngIf="
        isScopeMasterDataLoaded &&
        isUsersMasterDataLoaded
      " class="search-component" [placeholder]="placeHolder" [errorText]="errorText" [advancedSearch]="true"
    [searchControls]="searchControl" [search]="getSearchResults" [advancedSearchMethod]="getAdvancedSearchResults">
  </bpt-search>
</div>
<div *ngIf="
      actionItemSearchResult != undefined &&
      isSearch &&
      actionItemSearchResult.length > 0 &&
      !spinnerOn
    ">
  <app-action-item-panel-list #actionItemPanelList [actionItemSearchResult]="actionItemSearchResult"
        (selectedItems)="linkedItemsSelectedData($event)"
        [enableCheckBoxes]="enableCheckBoxes"></app-action-item-panel-list>
</div>
<div class="displayCenter" *ngIf="
      (actionItemSearchResult == undefined ||
      actionItemSearchResult.length == 0) &&
      isSearch &&
      !spinnerOn
    ">
  <app-empty-results></app-empty-results>
</div>